import CreateAlbum from './CreateAlbum'

export default CreateAlbum
